import { render, staticRenderFns } from "./CampaignsList.vue?vue&type=template&id=81b21c1a&"
import script from "./CampaignsList.vue?vue&type=script&lang=js&"
export * from "./CampaignsList.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsList.vue?vue&type=style&index=0&id=81b21c1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports